import Filters from '@/components/analyticsPage/tabPanels/components/drawers/components/Filters';
import { useDataQuery } from '@/components/analyticsPage/tabPanels/components/drawers/dataDrawer/hooks/useDataQuery';
import DrawerInput from '@/components/analyticsPage/input/DrawerInput';
import { useStockdataQuery } from '@/components/analyticsPage/tabPanels/components/drawers/dataDrawer/components/stockDataTab/hooks/useStockdataQuery';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@/components/ui/checkbox';
import DatePicker from '@/components/ui/datepicker';
import { useSelector } from 'react-redux';

const StockdataTab = () => {
  const [setDataQuery] = useDataQuery();
  const [setStockdataQuery] = useStockdataQuery();
  const [t] = useTranslation('analytics');
  const query = useSelector((state: any) => state.analytics.dataQuery);

  return (
    <div className="space-y-3">
      <DrawerInput data={query} setQuery={setDataQuery} />
      <div className="w-full space-y-1 p-4">
        <div className="font-medium">{t('Time window')}</div>
        <div className="flex items-center gap-2">
          <DatePicker
            value={query.stockData?.from}
            onChange={(e) => setStockdataQuery({ from: e })}
            className="w-full"
          />
          <DatePicker
            value={query.stockData?.to}
            onChange={(e) => setStockdataQuery({ to: e })}
            className="w-full"
          />
        </div>
      </div>
      <div className="space-y-1 px-4">
        <div className="font-medium">{t('Index')}</div>
        <div>
          <div className="space-y-1 mb-1">
            <div className="flex items-center gap-2">
              <Checkbox
                checked
                disabled
                className="data-[state=checked]:bg-primary data-[state=checked]:border-primary border-primary"
              />
              Stock Name
            </div>
            <div className="flex items-center gap-2">
              <Checkbox
                checked
                disabled
                className="data-[state=checked]:bg-primary data-[state=checked]:border-primary border-primary"
              />
              Stock Code
            </div>
            <div className="flex items-center gap-2">
              <Checkbox
                checked
                disabled
                className="data-[state=checked]:bg-primary data-[state=checked]:border-primary border-primary"
              />
              Date
            </div>
          </div>
          <Filters
            filters={query.stockData.filters}
            setQuery={setStockdataQuery}
            originalFilter={query.stockData.filters}
          />
        </div>
      </div>
    </div>
  );
};

export default StockdataTab;
